export function rarityName (rarity) {
    switch (rarity) {
        case "common":
            return "gewöhnlich";
        case "rare":
            return "selten";
        case "epic":
            return "episch";
        case "legendary":
            return "legendär";
        default:
            throw Error(`No name defined for rarity: ${rarity}`);
    }
};

export function rarityColor (rarity) {
    switch (rarity) {
        case "common":
            return "#B3A9A3";
        case "rare":
            return "#0090D0";
        case "epic":
            return "#B030E0";
        case "legendary":
            return "#F58100";
        default:
            throw Error(`No color value defined for rarity: ${rarity}`);
    }
};